import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Form,
  FormGroup,
  FormInput,
  Button
} from "shards-react";

import { resetPasswordRequest } from "./../components/auth/UserFunctions";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";

class Register extends Component {
  constructor() {
    super();
    this.state = {
      email: "",
      dialogOpen: false,
      message: ""
    };
  }

  onSubmit = e => {
    e.preventDefault();
    resetPasswordRequest(this.state.email).then(res => {
      if (res.status == 404) {
        window.location.href = "/errors";
      } else {
        this.setState({ message: res.data.message, dialogOpen: true });
      }
    });
  };

  onChange = e => {
    this.setState({ email: e.target.value });
  };
  render() {
    return (
      <Container fluid className="main-content-container h-100 px-4">
        <Row noGutters className="h-100">
          <Col lg="3" md="5" className="auth-form mx-auto my-auto">
            <Card>
              <CardBody>
                {/* Logo */}
                <img
                  className="auth-form__logo d-table mx-auto mb-3"
                  src={require("../images/logoautocorp.png")}
                  alt="Shards Dashboards - Login Template"
                />

                {/* Title */}
                <h5 className="auth-form__title text-center mb-4">
                  Resetear contraseña
                </h5>

                {/* Form Fields */}
                <Form onSubmit={this.onSubmit}>
                  <Dialog
                    open={this.state.dialogOpen}
                    fullWidth
                    aria-labelledby="responsive-dialog-title"
                  >
                    <DialogTitle id="responsive-dialog-title">
                      {"Cambio de contraseña"}
                    </DialogTitle>
                    <DialogContent>
                      <DialogContentText>
                        {this.state.message}
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions disableSpacing="false">
                      <Button href="/login" variant="contained" color="primary">
                        Aceptar
                      </Button>
                    </DialogActions>
                  </Dialog>

                  <FormGroup>
                    <label htmlFor="exampleInputEmail1">Email</label>
                    <FormInput
                      type="email"
                      id="email"
                      onChange={this.onChange}
                      placeholder="Ingresa tu email"
                      autoComplete="email"
                    />
                    <small className="form-text text-muted text-center">
                      Recibirás un correo electrónico un link para cambiar tu
                      contraseña
                    </small>
                  </FormGroup>
                  <Button
                    pill
                    theme="accent"
                    className="d-table mx-auto"
                    type="submit"
                  >
                    Resetear
                  </Button>
                </Form>
              </CardBody>
            </Card>

            {/* Meta Details */}
            <div className="auth-form__meta d-flex mt-4">
              <Link to="/login" className="mx-auto">
                Volver al login
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default Register;
